import PermissionSectionContent from './components/PermissionsSectionContent'
import TotalWorkAssignments from './components/TotalWorkAssignments'
import UserProfileSection from './UserProfileSection'
import $ from 'jquery'
import ScrollUtils from '../util/ScrollUtils'
import {Feature} from '../features/constants'
import PermissionsDescriptionLightBox from '../administration/userManagement/PermissionsDescriptionLightBox'
import {AccessRights} from 'constants'

export default class UserATProfileSection extends UserProfileSection {
    init(lightBoxEl, userData, changesCallback, validateCallback, isInstantValidation, enabledFeatures, mailSettingsSpecified, isUserCannotSeenAnyPages) {
        const isPTOEnabled = enabledFeatures.hasOwnProperty(Feature.PTO)
        const isSickEnabled = enabledFeatures.hasOwnProperty(Feature.SDB)
        const isTTAEnabled = enabledFeatures.hasOwnProperty(Feature.TTA)
        const isLTTEnabled = enabledFeatures.hasOwnProperty(Feature.LTT)
        const isURAEnabled = enabledFeatures.hasOwnProperty(Feature.URA)
        const isBTYEnabled = enabledFeatures.hasOwnProperty(Feature.BTY)

        super.init(lightBoxEl, userData, changesCallback, validateCallback, isInstantValidation, isPTOEnabled, isSickEnabled, mailSettingsSpecified)

        const $permissionsContainer = $('#profilePopup_permissionsTable')
        new PermissionSectionContent({
            userRights: userData.userRights.set,
            isPTOEnabled: isPTOEnabled,
            isSickEnabled: isSickEnabled,
            isTTAEnabled: isTTAEnabled,
            isLTTEnabled: isLTTEnabled,
            isURAEnabled: isURAEnabled,
            isBTYEnabled: isBTYEnabled,
            teamAssignmentType: userData.teamAssignmentType,
            managementAssignmentsSelection: userData.managementAssignmentsSelection,
            usersCount: userData.usersCount,
            tasksCount: userData.cptCounters.tasks,
            projectsCount: userData.cptCounters.projects,
            customersCount: userData.cptCounters.customers
        }).init($permissionsContainer)

        new PermissionsDescriptionLightBox({
            additionalClass: 'userProfilePermissionInfo',
        }).init($('#profilePermissionsSection .aboutPermissionIcon'))

        new TotalWorkAssignments({
            hasEnterTTRight: userData.userRights.set[AccessRights.SUBMIT_TIME_TRACK],
            allWorkAssignments: userData.canWorkWithAllScope,
            nTasks: userData.nWorkAssignedTasks,
        }).init($('#userProfilePopup_content .workAssignmentsSection .content'))

        this.startingNewWeekRadio = $('input[name="' + this.lightBoxEl.id + '_startingNewWeekRadio"]')
        this.startingNewWeekRadio.change(() => { this.changesDetected() })
        this.startingNewWeekRadio.filter('[value="' + userData.keepAllTasksFromPreviousWeek + '"]').prop('checked', true)

        // warning about no rights
        if (isUserCannotSeenAnyPages) {
            $(".rightSection").find(".noPermissionsWarning").show()
        }

        return this
    }

    getStartingNewWeekOption() {
        return this.startingNewWeekRadio.filter(':checked').val()
    }

    scrollToPermissionsSection() {
        if (this.rightSectionScroll) {
            ScrollUtils.scrollIntoViewVertical(this.rightSectionScroll, $("#profilePermissionsSection")[0], ScrollUtils.POSITIONS.TOP, false, 500)
        }
    }
}



// WEBPACK FOOTER //
// ./web/js/userProfile/UserATProfileSection.js